/**
 * The International Telecommunication Union (ITU) define in the standards E.123
 * and E.164 that the prefix for International Direct Dalling (IDD) for the
 * North American Numbering Plan (NANP) is `1`. The NANP is a group formed by
 * USA and its territories, Canada, and some Caribbean countries. The NANP also
 * defines that all the phone numbers on this numbering plan consists of
 * 10 digits.
 */
const NANP_PHONE_NUMBER_PATTERN = /^(\+1)?(\S{3})(\S{3})(\d{4})$/;
const DEFAULT_OPTIONS = {
  parenthesis: true
};

/**
 * Format a 10-digit phone number. If it's not a 10-digit phone number, it will
 * return the stringified value if it's a non-empty `string` or `number`, or
 * `null` otherwise.
 *
 * @template {any} T
 * @param {T} phoneNumber
 * @param {object} [options]
 * @property {boolean} [options.parenthesis=true] If `true`, will format as (XXX) XXX-XXXX. If `false`, will format as XXX-XXX-XXXX. Default is `true`.
 * @returns {T extends string|number ? string : null}
 */
export default function formatPhoneNumber(phoneNumber, options) {
  const opts = {
    ...DEFAULT_OPTIONS,
    ...options
  };
  if (typeof phoneNumber !== 'string' && typeof phoneNumber !== 'number' || typeof phoneNumber === 'string' && phoneNumber.trim() === '') {
    return null;
  }
  const stringifiedPhoneNumber = String(phoneNumber);
  const result = stringifiedPhoneNumber.replaceAll(/[()-\s]/g, '').match(NANP_PHONE_NUMBER_PATTERN);
  if (result == null) {
    return stringifiedPhoneNumber;
  }
  const [,, areaCode, prefix, suffix] = result;
  if (opts.parenthesis) {
    return `(${areaCode}) ${prefix}-${suffix}`;
  }
  return `${areaCode}-${prefix}-${suffix}`;
}
//# sourceMappingURL=phone-number.js.map